import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-managefleet',
  templateUrl: './managefleet.component.html',
  styleUrls: ['./managefleet.component.scss']
})
export class ManageFleetComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
